import React from "react";
import {loaderBallHorizontalImage} from "../../Utils/embedImages";

const LoaderHorizontal: React.FC = ({}) => {

    return (
        <div className={'sl-loader-horizontal'}>
            <img src={loaderBallHorizontalImage} className={'loader-image'}/>
        </div>
    );
}

export default LoaderHorizontal;